/**
 * Klaviyo Embedded Form
 * 
 */

document.addEventListener('DOMContentLoaded', initEvents, false);

function initEvents() {

    window.addEventListener("klaviyoForms", function(event) {

        if(event.detail.type == "stepSubmit" && event.detail.formId == "TiugiM") {

            //First Step - Email Opt-In
            if(event.detail.metaData.$step_name == "Email Opt-In") {
                window.klaviyoForm = {};
                window.klaviyoForm.firstData = event.detail.metaData

                // Check if we have Bloomreach on the site
                if(window.exponea) {

                    // Customer Tracking
                    exponea.identify(
                        {
                            email_id: window.klaviyoForm.firstData.$email,
                        },
                        {
                            first_name: window.klaviyoForm.firstData.$first_name,
                            last_name: window.klaviyoForm.firstData.$last_name,
                            email: window.klaviyoForm.firstData.$email,
                            phone: window.klaviyoForm.firstData.$phone_number
                        }
                    );

                    // Consent Event - Marketing
                    exponea.track('consent', {
                        email: window.klaviyoForm.firstData.$email,
                        action: "accept",
                        category: "Marketing", 
                        valid_until: "unlimited",
                        message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                    });

                    // Consent Event - SMS
                    exponea.track('consent', {
                        email: window.klaviyoForm.firstData.$email,
                        action: "accept",
                        category: "SMS", 
                        valid_until: "unlimited",
                        message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                    });
                }
            }

            //Secong Step - SMS Opt-In
            if(event.detail.metaData.$step_name == "SMS Opt-In") {

                // Check if we have first data from first step
                if(window.klaviyoForm && window.klaviyoForm.firstData) {

                    window.klaviyoForm.secondData = event.detail.metaData;

                    // Check if we have Bloomreach on the site
                    if(window.exponea) {

                        // Customer Tracking
                        exponea.identify(
                            {
                                email_id: window.klaviyoForm.firstData.$email,
                            },
                            {
                                first_name: window.klaviyoForm.firstData.$first_name,
                                last_name: window.klaviyoForm.firstData.$last_name,
                                email: window.klaviyoForm.firstData.$email,
                                phone: window.klaviyoForm.firstData.$phone_number
                            }
                        );

                        //Clear city names
                        let cities = window.klaviyoForm.secondData["I want to hear about the following events"];
                        for (let i = 0; i < cities.length; i++) {
                            let city = cities[i];

                            if(city.includes("NYC")) {
                                city = "New York";
                            }
                            else if(city.includes("LA")) {
                                city = "Los Angeles";
                            }

                            window.klaviyoForm.secondData["I want to hear about the following events"][i] = city;
                        }


                        // Sign Up Event
                        exponea.track('sign_up_event', {
                            event: "GetUpdates",
                            formId: event.detail.formId,
                            companyId: event.detail.companyId,
                            formVersionId: event.detail.formVersionId,
                            first_name: window.klaviyoForm.firstData.$first_name,
                            last_name: window.klaviyoForm.firstData.$last_name,
                            email: window.klaviyoForm.firstData.$email,
                            phone_number: window.klaviyoForm.firstData.$phone_number,
                            source: window.klaviyoForm.firstData.$source,
                            consent_form_id: window.klaviyoForm.firstData.$consent_form_id,
                            consent_method: window.klaviyoForm.firstData.$consent_method,
                            consent_form_version: window.klaviyoForm.firstData.$consent_form_version,
                            sms_consent: true,
                            market: window.klaviyoForm.secondData["I want to hear about the following events"],
                            categories: window.klaviyoForm.secondData["But receive notifications for..."],
                            city_source: window.klaviyoForm.secondData["I want to hear about the following events"]
                        });

                        // Consent Event - Cities
                        cities = window.klaviyoForm.secondData["I want to hear about the following events"];
                        for (let i = 0; i < cities.length; i++) {
                            let city = cities[i];

                            exponea.track('consent', {
                                email: window.klaviyoForm.firstData.$email,
                                action: "accept",
                                category: city, 
                                valid_until: "unlimited",
                                message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                            });
                        }

                        // Consent Event - Categories
                        let categories = window.klaviyoForm.secondData["But receive notifications for..."];
                        for (let i = 0; i < categories.length; i++) {
                            let category = categories[i];

                            if(category.includes("Childrenswear")) {
                                category = "Children";
                            }
                            else if(category.includes("Womenswear")) {
                                category = "Womens";
                            }
                            else if(category.includes("Menswear")) {
                                category = "Mens";
                            }

                            exponea.track('consent', {
                                email: window.klaviyoForm.firstData.$email,
                                action: "accept",
                                category: category, 
                                valid_until: "unlimited",
                                message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                            });
                        }

                        /* Shopify Consent Event
                        exponea.track('shopify_consent', {
                            action: "accept",
                            category: "Marketing", 
                            valid_until: "unlimited"
                        });
                        */

                        window.klaviyoForm = {};
                    }
                }
            }
        }
    });
}